// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { FunctionalComponent, h } from '@stencil/core';

interface BonusCodeProps {
    isFeatured?: boolean;
    bonusCode: string;
    bonusCodeWasClicked: boolean;
    includeDescriptor?: boolean;
    handleClick: () => void;
    className?: string;
    labelText?: string;
    noCodeLabel?: string;
}

const BonusCode: FunctionalComponent<BonusCodeProps> = ({
    isFeatured = false,
    bonusCode,
    bonusCodeWasClicked,
    handleClick,
    includeDescriptor = true,
    className = '',
    labelText = 'Promo Code',
    noCodeLabel = 'No Code Needed',
}) => {
    function handleBonusCodeClick(e: Event) {
        e.preventDefault();
        e.stopPropagation();

        if ('clipboard' in navigator) {
            void navigator.clipboard.writeText(bonusCode).then(() => {
                handleClick();
            });
        }
    }

    function handleNoCode(e: Event) {
        e.preventDefault();
        e.stopPropagation();
    }

    return bonusCode ? (
        <div
            onClick={handleBonusCodeClick}
            class={`${isFeatured ? 'featured-bonus' : 'bonus'} bam-bonus-code ${className}`}
        >
            {!bonusCodeWasClicked ? (
                <div class="bonus-container">
                    <div class="bonus-code">{bonusCode}</div>
                    {includeDescriptor && <div class="bonus-text">{labelText}</div>}
                </div>
            ) : (
                <div class="bonus-copy">Copied!</div>
            )}
        </div>
    ) : (
        <div
            onClick={handleNoCode}
            class={`${isFeatured ? 'featured-bonus' : 'bonus'} no-code bam-no-code ${className}`}
        >
            {noCodeLabel}
        </div>
    );
};

export default BonusCode;
